import angular from 'angular';
import headerCoreComponent from './header-core.component';
import CategoriesMenuModule from '../home/categories-menu/categories-menu';
// import RegisterService from './register.service';
 import headerCoreConfig from './header-core.config';
import accountMenuDirective from "./account-menu/account-menu";
import categoriesInputFilter from "../catalog/categories-filter/categories-input-filter/categories-input-filter";
import CategoriesSliderFilterModule
  from "../catalog/categories-filter/categories-slider-filter/categories-slider-filter";
import CategoriesSynchronousFilterModule
  from "../catalog/categories-filter/categories-synchronous-filter/categories-synchronous-filter";
import CategoriesAccordionModule from "../catalog/categories-filter/categories-accordion/categories-accordion";


let headerCoreModule = angular.module('app.headerCore',[
  accountMenuDirective.name,
  CategoriesMenuModule.name
])
.component('headerCore', headerCoreComponent)
// .service('RegisterService', RegisterService)
.config(headerCoreConfig);

export default headerCoreModule;







/** WEBPACK FOOTER **
 ** ./www/components/header-core/header-core.js
 **/